import * as tslib_1 from "tslib";
import React, { useRef, useState, useCallback, useContext } from 'react';
import classnames from 'classnames';
import ErrorBoundary from '../../ErrorBoundary';
import BurgerMenu from './BurgerMenu';
import SearchPopup from '../_partials/SearchPopup/SearchPopup';
import { URLS } from '@wix/da-url/dist/src/constants';
import { ThemeOptions } from '../../publicSession';
import CartIcon from '../../Icons/Cart';
import { IconSize } from '../../Icons/IconWrap';
import Logo from '../../Logo';
import shortenNumber from '../../utils/shortenNumber';
import NotificationsDropdownMobileCR28M from './NotificationsDropdownMobile';
import UserMenu from './UserMenu';
import { BiEventType, BiLink } from '../../biLogger';
import { ThemeContext } from '../../Context/ThemeContext';
import s from './SiteHeaderMobile.scss';
var limitNumber = function (number) {
    return number > 999 ? shortenNumber(number, 0, Math.floor) : "" + number;
};
function useSearchPopupState() {
    var searchPopupRef = useRef(null);
    var _a = useState(false), isSearchPopupShown = _a[0], setIsSearchPopupShown = _a[1];
    var toggleSearchPopup = useCallback(function () {
        setIsSearchPopupShown(function (shown) { return !shown; });
        if (searchPopupRef.current && searchPopupRef.current.focus) {
            searchPopupRef.current.focus();
        }
    }, []);
    var closeSearchPopup = useCallback(function () { return setIsSearchPopupShown(false); }, []);
    return {
        searchPopupRef: searchPopupRef,
        isSearchPopupShown: isSearchPopupShown,
        toggleSearchPopup: toggleSearchPopup,
        closeSearchPopup: closeSearchPopup,
    };
}
function useNotificationPopupState() {
    var _a = useState(false), isNotificationsPopupShown = _a[0], setIsNotificationsPopupShown = _a[1];
    var closeNotificationsPopup = useCallback(function () { return setIsNotificationsPopupShown(false); }, []);
    var toggleNotificationsPopup = useCallback(function () { return setIsNotificationsPopupShown(function (shown) { return !shown; }); }, []);
    return {
        isNotificationsPopupShown: isNotificationsPopupShown,
        closeNotificationsPopup: closeNotificationsPopup,
        toggleNotificationsPopup: toggleNotificationsPopup,
    };
}
var SiteHeaderMobile = function (_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    var _b = useSearchPopupState(), searchPopupRef = _b.searchPopupRef, isSearchPopupShown = _b.isSearchPopupShown, toggleSearchPopup = _b.toggleSearchPopup, closeSearchPopup = _b.closeSearchPopup;
    var _c = useNotificationPopupState(), isNotificationsPopupShown = _c.isNotificationsPopupShown, toggleNotificationsPopup = _c.toggleNotificationsPopup, closeNotificationsPopup = _c.closeNotificationsPopup;
    var theme = useContext(ThemeContext);
    var isDarkTheme = theme === ThemeOptions.DARK;
    return (React.createElement(ErrorBoundary, { className: classnames(s['root'], className) },
        React.createElement("header", { className: classnames(s['root'], s['sticky-header'], className) },
            React.createElement("div", { className: s['header'] },
                React.createElement("div", { className: s['left'] }, props.cartCount > 0 && (React.createElement(BiLink, { biData: {
                        evid: BiEventType.TOP_NAV_CLICK,
                        link_name: 'cart',
                        link_url: URLS.CART,
                        indicator: props.cartCount,
                    }, href: URLS.CART, className: s['icon-button'] },
                    React.createElement(CartIcon, { className: s['cart-icon'], size: IconSize.MEDIUM, withPadding: true }),
                    React.createElement("span", { className: s['number-label__green'] },
                        React.createElement("span", { className: s['number'] }, props.cartCount > 99 ? '99+' : props.cartCount))))),
                React.createElement("div", { className: s['middle'] },
                    React.createElement(BiLink, { biData: {
                            evid: BiEventType.TOP_NAV_CLICK,
                            link_name: 'logo',
                            link_url: URLS.ROOT,
                        }, href: URLS.ROOT, className: s['logo-link'] },
                        React.createElement(Logo, { textColor: isDarkTheme ? 'white' : 'black', size: "tiny" }),
                        ['rc', 'dev'].includes(String(props.environment)) && (React.createElement("div", { className: s['env'] }, String(props.environment).toUpperCase())))),
                React.createElement("div", { className: s['right'] },
                    isSearchPopupShown && (React.createElement(SearchPopup, { onClose: closeSearchPopup, isMobile: true, ref: searchPopupRef })),
                    props.isLoggedIn && (React.createElement(NotificationsDropdownMobileCR28M, { feedbackCount: limitNumber(props.feedbackCount), isOpen: isNotificationsPopupShown, onClick: toggleNotificationsPopup, onClose: closeNotificationsPopup })),
                    React.createElement(UserMenu, tslib_1.__assign({ isOpen: props.isUserDropdownOpen, onOpen: closeNotificationsPopup }, props, { hideNotificationCount: true })))),
            React.createElement("div", { className: s['burger-button'] },
                React.createElement(BurgerMenu, { activeMainMenuItem: props.activeMainMenuItem, onOpenMobileSearch: toggleSearchPopup, redirectOnSubmit: props.isLegacyHeader })))));
};
export default SiteHeaderMobile;
//# sourceMappingURL=SiteHeaderMobile.js.map